<script setup lang="ts"></script>

<template>
  <div class="form">
    <slot />
  </div>
</template>

<style scoped lang="scss">
  .form {
    --gap: var(--mp-space-50);

    display: flex;
    gap: var(--gap);
    flex-wrap: wrap;
    width: 100%;

    :slotted(.form__row-full) {
      flex-basis: 100%;
    }

    :slotted(.form__row-half) {
      flex-basis: 100%;

      @include screen-md {
        flex-basis: calc(50% - (var(--gap) * 1 / 2));
      }
    }

    :slotted(.form__row-third) {
      flex-basis: 100%;

      @include screen-md {
        flex-basis: calc(33.33% - (var(--gap) * 2 / 3));
      }
    }
  }
</style>
